module.exports = __webpack_public_path__ + "media/images/logo-footer-443b356b92d00496c82e624ef52621d7.png";